class CaseTypeSection {
  constructor() { }
}
CaseTypeSection.prototype.getClassBy = function (value) {
  var data = {
    Rover: ".case-info-section.case-rover",
    Duo: ".case-info-section.case-duo",
    Unique: ".case-info-section.case-unique",
    Rex: ".case-info-section.case-rex",
    Pro: ".case-info-section.case-pro",
    Sport: ".case-info-section.case-sport",
    Pop: ".case-info-section.case-pop",
    "Classic 2": ".case-info-section.case-classic2",
    Classic: ".case-info-section.case-classic",
    "Standout": ".case-info-section.case-standout"
  };
  return data[value] ?? ".case-info-section.case-classic";
};
CaseTypeSection.prototype.getNameTypeOnly = function (value) {
  // special case for Classic 2
  if (value == "Classic 2") return value;
  // Unique 3 => Unique
  var nameTypeOnly = value.split(" ")[0];
  return nameTypeOnly;
}
CaseTypeSection.prototype.show = function (value) {

  var nameTypeOnly = this.getNameTypeOnly(value);
  var selector = this.getClassBy(nameTypeOnly);
  $(".case-info-section").hide();
  $(`${selector} .section-revealed-image`).show().css("display", "inline");
  $(selector).show();
};
CaseTypeSection.prototype.addeventlistener = function (container) {
  var _this = this;

  container.find("input").on("change", function () {
    var value = $(this).val();
    _this.show(value);
  });
};
CaseTypeSection.prototype.init = function () {
  var container = $("variant-picker fieldset").first();
  var value = container.find("input:checked").val();
  this.show(value);
  this.addeventlistener(container);
};
class LabelOptionChange {
  constructor() { }
  getLableOption(container) {
    return container.find("variant-option-value");
  }
  addeventlistener() {
    var _this = this;
    var containers = $("variant-picker fieldset");
    containers.each(function () {
      var container = $(this);
      var lable_option = _this.getLableOption(container);
      container.find("input").on("change", function () {
        var value = $(this).val();
        lable_option.html(value);
      });
    });
  }
}

$(document).ready(function () {
  // If the variant picker custom element is already present, new variant picker not needed
  if ($("variant-picker-custom").length > 0) {
    return;
  }
  var caseTypeSection = new CaseTypeSection();
  caseTypeSection.init();
  var labelOptionChange = new LabelOptionChange();
  labelOptionChange.addeventlistener();
});
